module.exports = __webpack_public_path__ + "static/media/review-logo.b2909ecc.svg";